import script from "./RegisterSurveysForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterSurveysForm.vue?vue&type=script&setup=true&lang=js"

import "./RegisterSurveysForm.vue?vue&type=style&index=0&id=4df01134&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4df01134"]])

export default __exports__